import type {SxProps, Theme} from '@mui/material';

import {orangeColors, semantic} from '../../../../../layouts/theme/designSystem';

export const analysisInputPaperSx: SxProps<Theme> = {
  border: `1px solid ${orangeColors[3]}`,
  borderRadius: '14px',
  p: 2.5,
  mb: 2.5,
};

export const analysisInputSectionLabelSx: SxProps<Theme> = {
  fontWeight: 600,
  color: semantic.info.fg,
};

export const analysisInputMetaLabelSx: SxProps<Theme> = {
  fontWeight: 600,
  color: semantic.info.fg,
};

export const analysisInputExpandIconSx = (expanded: boolean): SxProps<Theme> => ({
  fontSize: 22,
  color: semantic.info.fg,
  transform: expanded ? 'rotate(180deg)' : 'none',
  transition: 'transform 0.2s ease',
});

export const getAnalysisInputHeaderSx = (isOpen: boolean, alwaysExpanded: boolean): SxProps<Theme> => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: 2,
  mb: isOpen ? 2 : 0,
  ...(!alwaysExpanded && {cursor: 'pointer', userSelect: 'none'}),
});

export const analysisInputListItemDividerSx: SxProps<Theme> = {
  mb: 1.5,
  pb: 1.5,
  borderBottom: `1px solid ${orangeColors[3]}`,
  '&:last-child': {mb: 0, pb: 0, borderBottom: 0},
};

export const analysisInputGridRowSx: SxProps<Theme> = {
  py: 0.75,
  borderBottom: `1px solid ${orangeColors[3]}`,
};
